import { render, staticRenderFns } from "./FormActividad.vue?vue&type=template&id=6b136090&"
import script from "./FormActividad.vue?vue&type=script&lang=js&"
export * from "./FormActividad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports